import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "collapsibleElement", "collapserControl" ]

  connect() {
    this._handleOutsideClick = this._handleOutsideClick.bind(this)
    this._handleEscape = this._handleEscape.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this._handleOutsideClick)
    document.removeEventListener("keydown", this._handleEscape)
  }

  toggleCollapse(ev) {
    // Only respond to click, Enter, or Space
    if (ev.type === 'keydown' && !(ev.key === 'Enter' || ev.key === ' ')) return;
    this._toggleIcons();
    this.collapsibleElementTarget.classList.toggle("hidden");

    // Find header and region for ARIA
    const header = this.element.querySelector('[role="button"]');
    const region = this.collapsibleElementTarget;
    const expanded = !region.classList.contains("hidden");
    if (header) header.setAttribute("aria-expanded", expanded ? "true" : "false");
    if (region) region.setAttribute("aria-hidden", expanded ? "false" : "true");

    if (expanded) {
      document.addEventListener("click", this._handleOutsideClick);
      document.addEventListener("keydown", this._handleEscape);
    } else {
      document.removeEventListener("click", this._handleOutsideClick);
      document.addEventListener("keydown", this._handleEscape);
    }
  }

  _toggleIcons() {
    if (
      this.collapserControlTarget.classList.contains("icon-open-box") ||
      this.collapserControlTarget.classList.contains("icon-close-box")
    ) {
      this.collapserControlTarget.classList.toggle("icon-open-box")
      this.collapserControlTarget.classList.toggle("icon-close-box")
    } else if (
      this.collapserControlTarget.classList.contains("open-icon") ||
      this.collapserControlTarget.classList.contains("closed-icon")
    ) {
      this.collapserControlTarget.classList.toggle("open-icon")
      this.collapserControlTarget.classList.toggle("closed-icon")
    }
  }

  _handleOutsideClick(ev) {
    // Ignore clicks inside this dropdown or button
    const eventPath = typeof ev.composedPath === 'function' ? ev.composedPath() : []
    const isInsideDropdown = this.element.contains(ev.target) || eventPath.includes(this.element)
    const isRemoveButton = ev.target.closest("[data-action*='group-selection#removeGroup']")
    if (isInsideDropdown || isRemoveButton) return
    this._close()
  }

  _handleEscape(ev) {
    if (ev.key === "Escape") {
      this._close()
    }
  }

  _close() {
    if (!this.collapsibleElementTarget.classList.contains("hidden")) {
      this.collapsibleElementTarget.classList.add("hidden")
      this._toggleIcons()
      document.removeEventListener("click", this._handleOutsideClick)
      document.removeEventListener("keydown", this._handleEscape)
    }
  }
}

